import { render, staticRenderFns } from "./editChannel.vue?vue&type=template&id=21fa1cda&scoped=true&"
import script from "./editChannel.vue?vue&type=script&lang=js&"
export * from "./editChannel.vue?vue&type=script&lang=js&"
import style0 from "./editChannel.vue?vue&type=style&index=0&id=21fa1cda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa1cda",
  null
  
)

export default component.exports